export * from "./Controls/_Public";
export * from "./Enums/_Public";
export * from "./Grids/_Public";
export * from "./Service/_Public";
export * from "./Configuration/_Public";
export * from "./Core/Events/EventTypes/_Public";

import { $dms as DMSSelector } from "./Core";

import {
    AppContext as DMSAppContext,
    QueryParameter as DMSQueryParameter,
    ApplicationParameter as DMSApplicationParameter,
    Navigation as DMSNavigation,
    ParentChild as DMSParentChild,
    Util as DMSUtil,
    Login as DMSLogin,
    Register as DMSRegister,
    ChangePassword as DMSChangePassword,
    SendResetPassword as DMSSendResetPassword,
    ResetPassword as DMSResetPassword,
    App as DMSApp,
    Auth as DMSAuth,
    DMSMenu as DMSMenu2,
    Breadcrumb as DMSBreadcrumb,
} from "./Core";
import { ServiceProvider as DMSServiceProvider } from "Service";
import {
    reloadGrids as DMSreloadGrids,
    hideGrids as DMShideGrids,
    initializeMappingInContainer as DMSinitializeMappingInContainer,
} from "Core";
import { TooltipExtension as DMSTooltipExtension } from "Grids/Extension";

export const QueryParameter = DMSQueryParameter;
export const ApplicationParameter = DMSApplicationParameter;
export const Navigation = DMSNavigation;
export const ParentChild = DMSParentChild;
export const Login = DMSLogin;
export const ChangePassword = DMSChangePassword;
export const SendResetPassword = DMSSendResetPassword;
export const ResetPassword = DMSResetPassword;
export const Util = DMSUtil;
export const reloadGrids = DMSreloadGrids;
export const hideGrids = DMShideGrids;
export const initializeMappingInContainer = DMSinitializeMappingInContainer;
export const TooltipExtension = DMSTooltipExtension;
export const App = DMSApp;
export const Auth = DMSAuth;
export const Menu = DMSMenu2;
export const Register = DMSRegister;
export const Breadcrumb = DMSBreadcrumb;

/**
 * @hidden
 */
export const Context = DMSAppContext;
DMSServiceProvider.init();
export const Service = DMSServiceProvider.current;
export const ServiceProvider = DMSServiceProvider;

(<any>window).$dms = DMSSelector;
